import React from 'react';
import { fireEvent, render, screen } from '@testing-library/react';

import ConfigProvider from 'components/ConfigProvider';

import GuardedCheckbox from './GuardedCheckbox';

const LABEL = 'Fleet Admin for Account Name A';
const REASON = 'You cannot modify your own roles.';

const renderCheckbox = (props = {}) =>
  render(
    <ConfigProvider>
      <GuardedCheckbox label={LABEL} onChange={() => {}} {...props} />
    </ConfigProvider>,
  );

describe('GuardedCheckbox', () => {
  it('renders a bare checkbox when there is nothing to explain', () => {
    renderCheckbox({ checked: true });

    expect(screen.getByRole('checkbox', { name: LABEL })).toBeChecked();
    expect(screen.queryByLabelText(new RegExp(REASON))).not.toBeInTheDocument();
  });

  it('reports the new value rather than the event', () => {
    const onChange = jest.fn();
    renderCheckbox({ checked: false, onChange });

    fireEvent.click(screen.getByRole('checkbox', { name: LABEL }));

    expect(onChange).toHaveBeenCalledWith(true);
  });

  it('keeps the input disabled while still explaining why', () => {
    renderCheckbox({ checked: true, disabled: true, lockReason: REASON });

    expect(screen.getByRole('checkbox', { name: LABEL })).toBeDisabled();
    expect(
      screen.getByLabelText(`${LABEL} — ${REASON}`),
    ).toBeInTheDocument();
  });

  it('attaches the tooltip to a focusable wrapper, not to the input', () => {
    renderCheckbox({ checked: true, disabled: true, lockReason: REASON });

    const wrapper = screen.getByLabelText(`${LABEL} — ${REASON}`);
    const input = screen.getByRole('checkbox', { name: LABEL });

    expect(wrapper).not.toBe(input);
    expect(wrapper).toContainElement(input);
    expect(wrapper).toHaveAttribute('tabindex', '0');
    expect(wrapper).not.toBeDisabled();
  });

  it('shows the reason on focus, which is how a keyboard reaches it', () => {
    renderCheckbox({ checked: true, disabled: true, lockReason: REASON });

    fireEvent.focus(screen.getByLabelText(`${LABEL} — ${REASON}`));

    expect(screen.getByText(REASON)).toBeInTheDocument();
  });

  it('gives a read-only page no tooltip, only a disabled control', () => {
    renderCheckbox({ checked: true, disabled: true });

    expect(screen.getByRole('checkbox', { name: LABEL })).toBeDisabled();
    expect(screen.queryByText(REASON)).not.toBeInTheDocument();
  });
});
